<template>
  <v-layout class="ats profile-experience" row wrap>
    <v-flex xs10 offset-xs1><v-divider /></v-flex>
    <v-flex xs10 offset-xs1>
      <v-card dark flat>
        <div class="text-xs-center pt-4">
          <div class="headline">Experience</div>
        </div>

        <v-tabs-items v-model="slide">
          <v-tab-item
            v-for="(experience, i) in sortedExperiences"
            :key="`experience-${i}`"
            @click="nextSlide"
          >
            <v-card flat>
              <v-layout align-center fill-height>
                <v-flex xs4 class="text-xs-center pt-3">
                  <v-avatar :size="150">
                    <img :src="experience.organization.logo" v-if="experience.organization.logo" />
                    <img src="/img/missing/logos/organizations/original.png" v-else />
                  </v-avatar>
                  <div
                    v-if="experience.startsAt || experience.endsAt"
                    class="pt-3"
                  >
                    <span v-if="experience.startsAt && experience.startsAt !== experience.endsAt">
                      {{ new Date(experience.startsAt) | date('MMM yyyy') }} -&nbsp;
                    </span>
                    <span v-if="experience.endsAt">
                      {{ new Date(experience.endsAt) | date('MMM yyyy') }}
                    </span>
                    <span v-else>Present</span>
                  </div>
                  <div
                    class="caption"
                    v-if="experience.startsAt !== experience.endsAt"
                  >
                    <span v-if="experience.endsAt">
                      {{ new Date(experience.startsAt) | inWords({ to: experience.endsAt }) }}
                    </span>
                    <span v-else> {{ new Date(experience.startsAt) | inWords }} </span>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <v-card-title primary-title>
                    <div>
                      <div class="title">{{ experience.position }}</div>
                      <div v-if="experience.organization.name">
                        {{ experience.type }} at {{ experience.organization.name }}
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text class="pt-0" v-if="experience.responsibilities">
                    <div>Responsibilities</div>
                    <div
                      v-for="(responsibility, i) in experience.responsibilities"
                      :key="i"
                      class="pt-2"
                    >
                      <v-icon left>mdi-clipboard-check</v-icon>
                      {{ responsibility }}
                    </div>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-tabs v-model="slide" slider-color="transparent" centered>
          <v-tab v-for="(experience, i) in sortedExperiences" :key="`experience-${i}`">
            <v-icon small>mdi-briefcase</v-icon>
          </v-tab>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: { experiences: Array },
  data() {
    return {
      slide: 0,
      sortedExperiences: [],
    }
  },

  mounted() {
    if (this.experiences && this.experiences[0]) {
      this.sortedExperiences = this.experiences.sort(({ endsAt: a }, { endsAt: b }) => {
        if (new Date(a) > new Date(b)) return -1
        if (new Date(a) < new Date(b)) return 1
        return 0
      })
    }
  },

  methods: {
    nextSlide() {
      if (this.slide + 1 < this.experiences.length) return this.slide++
      return (this.slide = 0)
    },
  },
}
</script>
